import followCursorBadge from "../utils/followCursorBadge";

// Badge "Découvrir" qui suit le curseur au survol des cartes du listing des solutions (zone = carte
// entière : son lien étiré capte le survol au-dessus du canvas 3D),
// comme sur les blocs 3D de la home (cf. BlockSolutions / BlockSolutionsCarousel).
export default class SolutionCardsBadge {
	constructor() {
		const badge = document.querySelector("[data-card-solution-badge]");
		if (!badge) return;

		document.querySelectorAll(".card-solution").forEach((zone) => followCursorBadge(zone, badge));
	}
}
